export default __webpack_public_path__ + "static/media/translate.d61207d6.svg";